import {observer} from "mobx-react";
import {Box} from "@mui/material";

function FormColumn({children}) {
    const style = styles()
    return (
        <Box sx={style.formColumnContainer}>
            {children}
        </Box>
    );
}

export default observer(FormColumn);

const styles = () => ({
    formColumnContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
});